import React from 'react';
import useDocumentTitle from '../useDocumentTitle'


import NavbarLearn from '../navbarLearn';
import Sidebar from '../learnSidebar';

export default function FiveC() {
    useDocumentTitle("Chapter 5 Lesson C | 101Learn by the Spartabots")
    return (
        <div>
            <NavbarLearn />
            <div class="flex max-w-[100rem] mx-auto my-5 bg-gradient-to-r from-frcyellow to-frcpurple rounded-[2rem] items-center">
                <p class="font-scoutcond font-black italic text-white opacity-50 text-[30rem] ml-10 leading-none">05-C</p>
                <h class="z-20 absolute font-scoutcond font-black italic text-frcblue text-[10rem] ml-40 leading-none">GEARBOX VIDEO</h>
                <p class="absolute ml-[9.4rem] mt-44 font-scoutcond font-black italic text-white text-[4rem] leading-none">LESSON 5-C</p>
            </div>
            <div class="flex flex-row max-w-[100rem] mx-auto mb-5">
                <div class="hidden md:flex basis-80 bg-gray-300 rounded-l-[2rem]">
                    <Sidebar />
                </div>
                <div class="basis-full h-full bg-gray-50 rounded-r-[2rem]">
                    <div class="mx-10 my-10">
                        <h class="font-scoutcond font-black italic text-[5rem] leading-none">LESSON OVERVIEW</h>
                        <p class="font-productsans font-bold text-3xl text-gray-400">Learn how to apply the concepts of the previous lesson to a drivetrain gearbox</p>
                        <p class="font-productsans text-base text-black mt-5">You'll be introduced to the a design video in ths lesson - to skip ahead, click on the chapter roadmap below:</p>
                        <a href="/learn/five">
                            <p class="font-avenir font-bold text-base text-frcblue mt-10 leading-none">CHAPTER 5</p>
                            <p class="font-scoutcond font-black text-[3rem] leading-none">ONSHAPE FOR FRC</p>
                        </a>
                        <div class="border-l-2 ml-5">
                            <ul class="font-productsans font-bold ml-3">
                                <li>
                                    <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/five/a">Onshape Featurescripts and Preexisting Libraries</a>
                                    <p class="font-productsans font-normal ml-3">Onshape features and community projects that make the designing process easier.</p>
                                </li>
                                <li>
                                    <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/five/b">FRC Design Calculator</a>
                                    <p class="font-productsans font-normal ml-3">Learn to make informed design decisions using a simplified calculator.</p>
                                </li>
                                <li>
                                    <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/five/c">Guided Gearbox Demonstration</a>
                                    <p class="font-productsans font-normal ml-3">Follow an example step-by-step to learn how to start designing.</p>
                                </li>
                            </ul>
                        </div>
                        <h class="block font-scoutcond font-black italic text-[5rem] leading-none mt-20">GUIDED GEARBOX TUTORIAL</h>
                        <p class="font-productsans text-lg text-black">Here is a simple FRC gearbox CAD video that demonstrates how to design from the numbers that we just managed to calculate in the previous step, courtesy of our our mentor, Archit S.</p>
                        <iframe class="my-5 rounded-[1rem]" width="560" height="315" src="https://www.youtube.com/embed/P0s7MwEkO3s" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        <p class="font-productsans text-lg text-black">Hopefully this video is informative and useful! If you have any questions or concerns, feel free to drop a message in the Discuss tab!</p>


                        <br></br>
                    
                    </div>
                </div>
            </div>
        </div>
    )
}